import React, { useState, Fragment, useEffect } from "react";
export default function Masking({ input, inputType, number }) {
    const [text, setText] = useState('');
    useEffect(() => {
        if (input !== "" && input !== undefined && input !== null) {
            if (number === undefined || number === null || number === '') {
                number = 1;
            }
            if (inputType === "mobile") {
                let maskedValue = "";
                for (let i = 0; i < input.length - number; i++) {
                    maskedValue += "X";
                }
                setText(maskedValue + input.substring(input.length - number, input.length));
            }
            else if (inputType === "email") {
                let maskedvalue = input.replace(/()(.*)(?=@)/,
                    function (gp1, gp2, gp3) {
                        for (let i = 0; i < gp3.length; i++) {
                            gp2 += "X";
                        } return gp2;
                    });
                setText(maskedvalue)
            }
        }
    }, [input]);

    return <Fragment>{text}</Fragment>;
}